import { createFileRoute } from '@tanstack/react-router'

import { MenuManagement } from '#components/features/products/menu-management'
import { MenuSectionNavigation } from '#components/features/products/menu-section-navigation'
import { PageHeader } from '#components/layout/page-header'

export const Route = createFileRoute('/_auth/_admin/cardapio/')({
  head: () => ({
    meta: [
      { title: 'Cardápio | UseComanda' },
      {
        name: 'description',
        content: 'Gerencie produtos, preços e disponibilidade do cardápio.',
      },
    ],
  }),
  component: ProductsPage,
})

function ProductsPage() {
  return (
    <main className="bg-muted/20 min-h-full px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl space-y-6">
        <PageHeader
          eyebrow="Cardápio"
          title="Cardápio"
          subtitle="Gerencie os itens, preços e disponibilidade do seu cardápio."
        />
        <MenuSectionNavigation />
        <MenuManagement />
      </div>
    </main>
  )
}
